import { BEFORE_SETTINGS, GET_SETTINGS, CREATE_NEWSLETTER, BEFORE_NEWSLETTER } from '../../../redux/types';

const initialState = {
    settings: null,
    settingsAuth: false,
    newsLetter: null,
    newsLetterAuth: false
}

export default function footerRed(state = initialState, action) {
    switch (action.type) {
        case GET_SETTINGS:
            return {
                ...state,
                settings: action.payload,
                settingsAuth: true
            }
        case BEFORE_SETTINGS:
            return {
                ...state,
                settings: null,
                settingsAuth: false
            }
        case CREATE_NEWSLETTER:
            return {
                ...state,
                newsLetter: action.payload,
                newsLetterAuth: true
            }
        case BEFORE_NEWSLETTER:
            return {
                ...state,
                newsLetter: null,
                newsLetterAuth: false
            }
        default:
            return {
                ...state
            }
    }
}